import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from "@angular/forms";
import { ActionConfig, ActionDto, ActionModal, ModalService, WebAppCommonModule } from "@allbesmart/web-app-common";

@Component({
    selector: 'oaibox-gnb-upgrade-uhd-config-action-modal',
    templateUrl: './gnb-upgrade-uhd-config-action-modal.component.html',
    styleUrls: ['./gnb-upgrade-uhd-config-action-modal.component.css'],
    imports: [WebAppCommonModule, ReactiveFormsModule]
})
export class GnbUpgradeUhdConfigActionModalComponent implements ActionModal {

  @Input({required: true}) public actionConfig!: ActionConfig;
  @Input({required: true}) public sendAction!: (actionDto: GNBUpgradeUHDActionDto) => void;

  protected uhdForm: FormGroup<{ uhdVersion: FormControl }>;

  constructor(private modalService: ModalService) {
    this.uhdForm = new FormGroup<{ uhdVersion: FormControl }>({
      uhdVersion: new FormControl<string | null>(null, [Validators.required])
    });
  }

  public confirmAction(): void {
    if (this.uhdForm.valid) {
      this.sendAction({
        type: this.actionConfig.type,
        command: this.actionConfig.command,
        configuration: {
          branch: this.uhdForm.controls.uhdVersion.value
        }
      });
      this.modalService.popModal();
    }
  };

  protected cancel(): void {
    this.modalService.popModal();
  }

}

export interface GNBUpgradeUHDActionDto extends ActionDto {
  configuration?: { branch: string };
}
